import Proxies from "./proxies";

export default Proxies;
